import { byMethod } from '@oysterjs/core/graphql/actions';
import { merge } from '@oysterjs/core/graphql/loaders';
import type { RouteObject } from 'react-router-dom';
import {
  submitArchiveWordDocumentTemplates,
  submitCreateWordDocumentTemplate,
  submitUpdateWordDocumentTemplate,
  submitUpdateWordDocumentTemplatesVisibility
} from '~/api/data/word-templates/mutations';
import {
  loadWordDocumentTemplate,
  loadWordDocumentTemplates
} from '~/api/data/word-templates/queries';
import { LibraryWordTemplatesPage, WordTemplateEditPage } from '~/pages/library/word-templates';

const wordDocumentTemplateLibraryChildren = [
  {
    path: 'archive',
    action: byMethod({
      POST: submitArchiveWordDocumentTemplates
    })
  },
  {
    path: 'visibility',
    action: byMethod({
      POST: submitUpdateWordDocumentTemplatesVisibility
    })
  },
  {
    // Element-less: the upload UI lives on the parent list page as a modal.
    // This route exists only so the dialog can POST a multipart upload here
    // via `useFetcher` and have the parent loader revalidate automatically.
    path: 'new',
    action: byMethod({
      POST: submitCreateWordDocumentTemplate
    })
  },
  {
    path: ':id',
    loader: merge({
      wordDocumentTemplate: loadWordDocumentTemplate
    }),
    action: byMethod({
      PUT: submitUpdateWordDocumentTemplate
    }),
    element: <WordTemplateEditPage />
  }
];

export const wordTemplatesRoute: RouteObject = {
  path: 'word-templates',
  loader: merge({
    wordDocumentTemplates: loadWordDocumentTemplates
  }),
  element: <LibraryWordTemplatesPage />,
  children: wordDocumentTemplateLibraryChildren
};
